import { showAlert } from "@components/alert/action";
import { showBettoAlert } from "@layouts/betto/components/Alert/showBettoAlert";
import {
	Content,
	FailureImg,
	ResultContent,
	ResultText,
	SuccessImg,
} from "@pages/profile-v2/pages/deposit/baseItems";
import React, { useEffect } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

function Result({ location, showAlert: dispatchShowAlert }) {
	const params = new URLSearchParams(location.search);
	const transactionId = params.get("transaction_id");
	const amountFormatted = params.get("amount_formatted");
	const currency = params.get("currency");
	const status = params.get("status");
	const statusDescription = params.get("status_description");
	const isBetto = window.TENANT === "betto";
	const isApproved = status === "APPROVED";
	const isFailed = Boolean(status) && !isApproved;
	const hideInlineResult = isBetto && (isApproved || isFailed);

	useEffect(() => {
		if (!isBetto) {
			return;
		}

		if (isApproved) {
			showBettoAlert(dispatchShowAlert, "deposit-completed");
			return;
		}

		if (isFailed) {
			showBettoAlert(dispatchShowAlert, "payment-failed");
		}
	}, [dispatchShowAlert, isBetto, isApproved, isFailed]);

	return (
		<Translate>
			{({ translate }) => (
				<Content>
					{!hideInlineResult ? (
						<ResultContent>
							{isApproved ? <SuccessImg /> : <FailureImg />}
							<ResultText>
								{isApproved
									? translate("DEPOSIT_SUCCESS_TITLE")
									: translate("DEPOSIT_FAILED_TITLE")}
							</ResultText>
							<ResultText>
								<div className="detail">
									{isApproved
										? translate("DEPOSIT_SUCCESS", {
												transactionId,
												amountFormatted,
												currency,
											})
										: translate("DEPOSIT_FAILED", {
												statusDescription,
												transactionId,
											})}
								</div>
							</ResultText>
						</ResultContent>
					) : null}
				</Content>
			)}
		</Translate>
	);
}

const mapDispatchToProps = { showAlert };

export default connect(null, mapDispatchToProps)(withRouter(Result));
